<input #input hidden [id]="controlId" [value]="value" />
<div
  [attr.contenteditable]="disabled ? false : 'plaintext-only'"
  #content
  class="textarea-input"
  [attr.data-placeholder]="placeholder"
  (input)="handleInput($event)"
  (paste)="handlePaste($event)"
  (blur)="handleBlur()"
  [class.error]="error"
  [class.disabled]="disabled"></div>
<div class="textarea-footer" *ngIf="hint || maxLength">
  <span class="hint" *ngIf="hint">{{ hint }}</span>
  <span class="char-count" *ngIf="maxLength">{{ input.value.length | number }}/{{ maxLength | number }}</span>
</div>
